import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Button } from 'react-bootstrap';
import InnerHtmlContent from '../InnerHtmlContent';

class CodeForm extends PureComponent {
  constructor(props) {
    super(props);
    this.setShowForm = this.setShowForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      showForm: false,
      value: '',
      isValid: false
    };
  }

  setShowForm(showForm) {
    this.setState({ showForm }, () => {
      this.props.onToggle(showForm);
      if (showForm) {
        this.codeInput.focus();
      }
    });
  }

  handleChange(event) {
    const value = event.target.value;
    const isValid = (value.length > 0);
    this.setState({
      value,
      isValid
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.onSubmit(this.state.value);
  }

  render() {
    const { t } = this.props;
    const formHidden = this.state.showForm ? '' : 'hidden';
    return (
      <div id="codeForm">
        <p className="code-form-title text-center">
          <InnerHtmlContent content={t('codeForm.infoText')} />
          {' '}
          { !this.state.showForm &&
            <Button
              bsStyle="link"
              className="basic-action-link action-link-among-text"
              onClick={(e) => { this.setShowForm(true) }}
            >
              {t('codeForm.showCodeInputLink')}
            </Button>
          }
        </p>
        <form className={`code-form ${formHidden}`} onSubmit={e => this.handleSubmit(e)}>
          <p className="form-input-group text-center">
            <input
              id="code"
              ref={(input) => { this.codeInput = input }}
              className={`code-input ${this.state.isValid ? 'is-valid' : ''}`}
              type="text"
              placeholder={t('codeForm.codePlaceholder')}
              onChange={this.handleChange}
            />
            <Button
              className="action-btn-small send-code-btn"
              type="submit"
              disabled={!this.state.isValid}
            >
              {t('codeForm.submitButtonText')}
            </Button>
          </p>
          <p>
            <Button
              bsStyle="link"
              className="basic-action-link close-code-form-link center-block"
              onClick={(e) => { this.setShowForm(false) }}
            >
              {t('codeForm.closeCodeInputLink')}
            </Button>
          </p>
        </form>
      </div>
    );
  }
}

CodeForm.propTypes = {
  onToggle: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default translate(['booking'])(CodeForm);



// WEBPACK FOOTER //
// ./src/components/CodeForm/index.jsx